import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FoodBankIcon(props: IconProps) {
    return <Icon {...props} iconKey={"food_bank"}/>
}
